import { DateTime } from "luxon";
import { ListarEdicoesParaCalendarioOutputDto } from "../domain/DTOs/output/jornal/listar-edicoes-para-calendario-output.dto";
import { DescricaoCalendario } from "../domain/enums/descricao-calendario.enum";
import { Cronogramas } from "../domain/modelsForComponents/cronograma.model";
import { StringUtils } from "./string.utils";

export class CommonConverter {
  public static convertToBase64(imageUrl: string | ArrayBuffer | null): Promise<string | null> {
    if (imageUrl === null)
      return Promise.resolve(null);

    if (typeof imageUrl === 'string') {
      return fetch(imageUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.arrayBuffer();
        })
        .then((arrayBuffer) => {
          return this.arrayBufferToBase64(arrayBuffer);
        });
    }

    if (imageUrl instanceof ArrayBuffer)
      return Promise.resolve(this.arrayBufferToBase64(imageUrl));

    throw new Error('Invalid input type');
  }

  public static uint8ArrayToImage(array: Uint8Array): string {

    if (array.length > 1e6) {
      throw new Error("O array de entrada é muito grande.");
    }

    const binaryString = String.fromCharCode(...array);

    const base64String = btoa(binaryString);

    return base64String;
  }

  public static convertArrayToBase64Image(byteArray: string): string {
    return `data:image/${StringUtils.GetFileExtension(byteArray)};base64,${byteArray}`;
  }

  private static arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const length = bytes.length;

    for (let i = 0; i < length; i++)
      binary += String.fromCharCode(bytes[i]);

    return window.btoa(binary);
  }

  public static formatDateToString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  public static removeSpecialCharacters(input: string): string {
    return input.replace(/[^a-zA-Z0-9 ]/g, '');
  }

  public static getMesLuxonDate(date: DateTime) {
    switch (date.month) {
      case 1: return 'Janeiro';
      case 2: return 'Fevereiro';
      case 3: return 'Março';
      case 4: return 'Abril';
      case 5: return 'Maio';
      case 6: return 'Junho';
      case 7: return 'Julho';
      case 8: return 'Agosto';
      case 9: return 'Setembro';
      case 10: return 'Outubro';
      case 11: return 'Novembro';
      case 12: return 'Dezembro';
      default: return 'Mês inválido';
    }
  }

  public static getDiaSemanaLuxonDate(date: DateTime) {
    switch (date.weekday) {
      case 1: return 'Segunda-feira';
      case 2: return 'Terça-feira';
      case 3: return 'Quarta-feira';
      case 4: return 'Quinta-feira';
      case 5: return 'Sexta-feira';
      case 6: return 'Sábado';
      case 7: return 'Domingo';
      default: return 'Dia inválido';
    }
  }

  // Conversores de DTOs

  public static converterParaCronogramas(dtos: ListarEdicoesParaCalendarioOutputDto[] | undefined): Cronogramas {
    const cronogramas: Cronogramas = {};

    if (dtos === undefined || dtos === null) return cronogramas;

    for (let i = 0; i < dtos?.length; i++) {
      const data = new Date(dtos[i].dataPublicacao);
      const dateKey = data.toISOString()?.split('T')[0] ?? 0;
      if (!cronogramas[dateKey]) {
        cronogramas[dateKey] = [];
      }

      if (dtos[i].edicaoOrdinaria) {
        cronogramas[dateKey].push(DescricaoCalendario.EdicaoOrdinaria);
      } 
      
      if (dtos[i].edicaoExtra) {
        cronogramas[dateKey].push(DescricaoCalendario.EdicaoExtra);
      }
    }

    return cronogramas;
  }
}
